import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Image from "../Images/Sahil_7.png";
import html5 from "../Images/html5.png";
import css3 from "../Images/css3.png";
import js from "../Images/js.png";
import node from "../Images/nodejs.png";
import rct from "../Images/R.png";
import mongo from "../Images/mongodb.png";
import tailwind from "../Images/tailwind.png";
import express from "../Images/express.png";
import Project from "./Project";
import newsLetter from "../Images/NewsLetter.png";
import keeper from "../Images/Keeper.png";
import blog from "../Images/Blog.png";

function About() {
  return (
    <div className="mt-28 md:mt-20">
      <Header />
      <div className="flex md:p-16 justify-center flex-col lg:flex-row">
        <div className="text-center flex justify-center p-8 lg:p-10">
          <img
            src={Image}
            className="avatar rounded-full mx-auto"
            class="avatar"
            alt="My_Img"
          />
        </div>
        <div className="p-10 lg:p-16 mt-7 text lg:w-1/2">
          <h2 className="text-4xl font-medium  text-slate-900 dark:text-slate-50 text-center m-3 transition-all ease-linear duration-200">
            ABOUT ME
          </h2>
          <p className="text-2xl lg:text-3xl text-slate-700 dark:text-slate-300  text-justify transition-all ease-linear duration-200">
            This is Sahil Dhoot. Currently, I'm pursing Computer Science and Engineering from IIIT
            Pune. A Tech-enthusiast always eager to learn and explore new
            domains of technology.
          </p>
        </div>
      </div>
      <div className="flex justify-center p-4 text">
        <h1 className="flex text-4xl font-medium text-slate-900 dark:text-slate-50 transition-all ease-linear duration-200">
          SKILLS
        </h1>
      </div>
      <div className="flex justify-center p-4 gap-10 flex-wrap m-10 transition-all ease-linear duration-200">
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-5 dark:text-white">HTML</span>
          <img src={html5} alt="" className="icon w-20 h-20"/>
        </div>
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-5 dark:text-white">CSS</span>
          <img src={css3} alt="" className="icon w-20 h-20"/>
        </div>
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-1 dark:text-white">Javascript</span>
          <img src={js} alt="" className="icon w-20 h-20"/>
        </div>
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-3 dark:text-white">Tailwind</span>
          <img src={tailwind} alt="" className="icon w-20 h-20"/>
        </div>
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-2 dark:text-white">React JS</span>
          <img src={rct} alt="" className="icon w-20 h-20"/>
        </div>
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-2 dark:text-white">Node JS</span>
          <img src={node} alt="" className="icon w-20 h-20"/>
        </div>
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-1 dark:text-white">Express JS</span>
          <img src={express} alt="" className="icon w-20 h-20"/>
        </div>
        <div className="has-tooltip flex rounded-full shadow-xl bg-slate-100 dark:bg-[#141619] p-3 transition-all ease-linear duration-200"> 
          <span className="tooltip mt-24 ml-2 dark:text-white">MongoDB</span>
          <img src={mongo} alt="" className="icon w-20 h-20"/>
        </div>
      </div>
      {/*  grayscale hover:grayscale-0 */}
      <div className="flex justify-center p-4 text">
        <h1 className="flex text-4xl font-medium text-slate-900 dark:text-slate-50 transition-all ease-linear duration-200">
          PROJECTS
        </h1>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 justify-center p-10 gap-10">
        <Project
          title="NewsLetter Website"
          screenshot={newsLetter}
          desc="A web app using mailchimp api to collect users data."
          link="https://news-letter-1uxj.onrender.com/"
          tech={["Bootstrap","API"]}
        />
        <Project
          title="Note Keeper"
          screenshot={keeper}
          desc="A web app for creating and storing notes using react."
          link="https://note-keeper-app-h7yd.onrender.com/"
          tech={["React","MUI"]}
        />
        <Project
          title="Blog Website"
          screenshot={blog}
          desc="A web app for where user can edit and compose blogs."
          link=""
          tech={["Node","Express","MongoDB"]}
        />
      </div>
      <Footer />
    </div>
  );
}

export default About;
